export default "__VITE_ASSET__pZvTkUuJ__"